import { render, staticRenderFns } from "./OpportunityForm.vue?vue&type=template&id=2faf659e&scoped=true&"
import script from "./OpportunityForm.vue?vue&type=script&lang=js&"
export * from "./OpportunityForm.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityForm.vue?vue&type=style&index=0&id=2faf659e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf659e",
  null
  
)

export default component.exports